import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { IInput } from '../../components/Common/iComponents/iInput/iInput';
import { getNameClient } from '../../helpers/nameClient';
//redux
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Import Breadcrumb
import Breadcrumb from '../../components/Common/Breadcrumb/Breadcrumb';
import avatar from '../../assets/images/users/avatar-1.jpg';

// actions
import { viewProfile, resetStatus } from '../../store/actions';
import { updatePhotoProfile } from '../../store/auth/profile/actions';
import { IPopUp } from '../../components/Common/iComponents/iPopUp/IpopUp';
import FormChangePsw from './formChangePsw';
import IButtonComponent from '../../components/Common/iComponents/iButton/IButton';

import usePageTitle from '../../common/hooks/usePageTitle';

const UserProfile = (props: any) => {
    const dispatch = useDispatch();
    const [popUpState, setpopUpState] = useState(false);

    const PageTitleAPI = usePageTitle(props.location.pathname);

    const { error, success, profileData, isLoading } = useSelector((state: any) => ({
        error: state.profile.error,
        success: state.profile.success,
        profileData: state.profile.profileData,
        isLoading: state.profile.isLoading,
    }));
    const [FormInfo, setFormInfo] = useState([
        { name: 'last name', Info: profileData?.USUARIO_APELLIDO },
        { name: 'Email', Info: profileData?.USUARIO_CORREO },
        { name: 'ID no', Info: profileData?.id },
        { name: 'Tel', Info: profileData?.USUARIO_TELEFONO },
        { name: 'Network Id', Info: profileData?.NETWORK_ID },
        { name: 'Account Number', Info: profileData?.ACCOUNT_NUMBER },
    ]);

    const fileInput = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        const authUser: any = localStorage.getItem('authUser');
        if (authUser) {
            const obj = JSON.parse(authUser);
            if (process.env.REACT_APP_DEFAULTAUTH === 'fake' || process.env.REACT_APP_DEFAULTAUTH === 'jwt') {
                dispatch(viewProfile(obj));
            }
        }
    }, []);

    const [isPhotoLoading, setIsPhotoLoading] = useState(false);

    const [Photo, setPhoto] = useState(avatar);

    useEffect(() => {
        setIsPhotoLoading(isLoading);
    }, [isLoading]);

    useEffect(() => {
        setFormInfo([
            { name: 'last name', Info: profileData?.USUARIO_APELLIDO },
            { name: 'Email', Info: profileData?.USUARIO_CORREO },
            { name: 'ID no', Info: profileData?.id },
            { name: 'Tel', Info: profileData?.USUARIO_TELEFONO },
            { name: 'Network Id', Info: profileData?.NETWORK_ID },
            { name: 'Account Number', Info: profileData?.ACCOUNT_NUMBER },
        ]);

        setPhoto(profileData.URL_FOTO_PERFIL);
    }, [profileData]);

    useEffect(() => {
        dispatch(resetStatus());
    }, [popUpState == false]);

    const CloseModal = () => {
        setpopUpState(false);
    };

    const handleUploadClick = () => {
        if (fileInput.current) {
            fileInput.current.click();
        }
    };

    const handleFileChange = (e: any) => {
        let user: any;

        const getAuthUser = localStorage.getItem('authUser');

        if (getAuthUser) user = JSON.parse(getAuthUser);

        const file = e.target.files[0];
        if (file) {
            dispatch(updatePhotoProfile({ file: file, id: user.id, nameField: file.name }));
        }
    };

    const LoadingIndicator = () => {
        return (
            <div className="d-flex justify-content-center">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    };
    return (
        <React.Fragment>
            <div className="page-content">
                <PageTitle>
                    <title>
                        {PageTitleAPI.replace(/-/g, ' ')} | {getNameClient()}
                    </title>
                </PageTitle>
                {/* <PageTitle>
                    <title>{`${profileData.USUARIO_NOMBRE}-Profile`}</title>
                </PageTitle> */}
                <Container fluid>
                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody>
                                    <div className="d-flex-reverse">
                                        <div
                                            onClick={() => {
                                                handleUploadClick();
                                            }}
                                            className="container_imgProfile_Profile"
                                        >
                                            <img src={Photo} alt="" className="imgProfile_Profile" />
                                            <div className="container-sm">
                                                <>{isPhotoLoading ? LoadingIndicator() : null}</>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1 align-self-center ms-3">
                                            <div className="text-muted">
                                                <h5>{profileData.USUARIO_NOMBRE}</h5>
                                                <div className="container_FormInfo">
                                                    {FormInfo.map((i) => {
                                                        return <IInput title={i.name} value={i.Info} valid={false} type={'text'} readonly={true} />;
                                                    })}
                                                </div>
                                                {/* <p className="mb-0">C.C: {profileData.CEDULA}</p>
                        <p className="mb-0">Celular: {profileData.CELULAR}</p>
                        <p className="mb-0">Genero: {profileData.USUARIO_SEXO}</p> */}
                                                <div
                                                    className="d-flex justify-content-center"
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'flex-end',
                                                        marginTop: '',
                                                        marginRight: '1%',
                                                    }}
                                                >
                                                    <IButtonComponent
                                                        className="btn-wide"
                                                        actionOnClick={() => setpopUpState(true)}
                                                        label={'Change password'}
                                                        btnIcon={'bx bx-edit-alt'}
                                                    ></IButtonComponent>
                                                </div>
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    style={{ display: 'none' }}
                                                    onChange={handleFileChange}
                                                    ref={fileInput}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            <IPopUp
                stateAdd={popUpState}
                switchStateAdd={setpopUpState}
                modalTitleAdd={'Change Password'}
                modaleTitleUpdate={'Change Password'}
                icon="users"
                colorHeaderPop={'#101340'}
            >
                <FormChangePsw email={profileData.USUARIO_LOGIN} onCancel={CloseModal} onPasswordChanged={CloseModal} />
            </IPopUp>
        </React.Fragment>
    );
};

export default withRouter(UserProfile);
